import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine } from 'recharts';
import { dateLocale } from "../lib/languages";
import { useI18n } from '../lib/i18n';

const MoodChart = ({ data, averageMood }) => {
  const { t, locale } = useI18n();
  const dLocale = dateLocale(locale);

  const chartData = data.map(entry => ({
    date: new Date(entry.date).toLocaleDateString(dLocale, { day: '2-digit', month: 'short' }),
    mood: entry.mood,
    fullDate: entry.date
  }));

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const entry = data.find(d => 
        new Date(d.date).toLocaleDateString(dLocale, { day: '2-digit', month: 'short' }) === label
      );
      return (
        <div className="bg-background p-3 rounded-lg shadow-lg border">
          <p className="font-medium">{label}</p>
          <p className="text-primary">{t("chart.mood")}: {payload[0].value}/10</p>
          {entry?.emotions && entry.emotions.length > 0 && (
            <p className="text-sm text-muted-foreground mt-1">{entry.emotions.join(', ')}</p>
          )}
        </div>
      );
    }
    return null;
  };

  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center h-64 text-muted-foreground">
        {t("chart.notEnoughData")}
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={chartData} margin={{ top: 20, right: 20, left: 0, bottom: 20 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
        <XAxis dataKey="date" tick={{ fontSize: 12, fill: 'hsl(var(--muted-foreground))' }} tickLine={false} axisLine={{ stroke: 'hsl(var(--border))' }} />
        <YAxis domain={[0, 10]} tick={{ fontSize: 12, fill: 'hsl(var(--muted-foreground))' }} tickLine={false} axisLine={{ stroke: 'hsl(var(--border))' }} ticks={[0, 2, 4, 6, 8, 10]} />
        <Tooltip content={<CustomTooltip />} />
        {averageMood && (
          <ReferenceLine y={averageMood} stroke="hsl(var(--accent))" strokeDasharray="5 5" label={{ value: `${t("chart.avg")} ${averageMood}`, fill: 'hsl(var(--accent))', fontSize: 12, position: 'right' }} />
        )}
        <Line type="monotone" dataKey="mood" stroke="hsl(var(--primary))" strokeWidth={2} dot={{ fill: 'hsl(var(--primary))', strokeWidth: 2, r: 4 }} activeDot={{ r: 6, fill: 'hsl(var(--primary))' }} />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default MoodChart;
